import { render, staticRenderFns } from "./OrderDeliveryIng.vue?vue&type=template&id=fc88a062&"
import script from "./OrderDeliveryIng.vue?vue&type=script&lang=ts&"
export * from "./OrderDeliveryIng.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports